import request from '@/utils/request'

// 分页查询检测项模板
export function getTemplateList(params) {
  return request({
    url: '/api/admin/inspection-template/list',
    method: 'get',
    params
  })
}

// 获取所有启用的检测项模板
export function getEnabledTemplates() {
  return request({
    url: '/api/admin/inspection-template/enabled',
    method: 'get'
  })
}

// 根据分类获取检测项模板
export function getTemplatesByCategory(category) {
  return request({
    url: '/api/admin/inspection-template/by-category',
    method: 'get',
    params: { category }
  })
}

// 获取所有分类
export function getCategories() {
  return request({
    url: '/api/admin/inspection-template/categories',
    method: 'get'
  })
}

// 添加检测项模板
export function addTemplate(data) {
  return request({
    url: '/api/admin/inspection-template/add',
    method: 'post',
    data
  })
}

// 更新检测项模板
export function updateTemplate(data) {
  return request({
    url: '/api/admin/inspection-template/update',
    method: 'post',
    data
  })
}

// 删除检测项模板
export function deleteTemplate(id) {
  return request({
    url: '/api/admin/inspection-template/delete',
    method: 'post',
    params: { id }
  })
}

// 批量删除检测项模板
export function batchDeleteTemplates(ids) {
  return request({
    url: '/api/admin/inspection-template/batch-delete',
    method: 'post',
    data: ids
  })
}

// 启用/禁用检测项模板
export function toggleTemplateStatus(id) {
  return request({
    url: '/api/admin/inspection-template/toggle-status',
    method: 'post',
    params: { id }
  })
}
